<div class="home-container">
  <h1>Bienvenido, {{ user?.name }} {{ user?.lastName }}</h1>
  <p>Username: {{ user?.username }}</p>
  <p>Email: {{ user?.email }}</p>
  <p>ID: {{ user?.id }}</p>

  @if (isLoggedIn()) {
    <button (click)="logout()">Cerrar sesión</button>
  }
</div>
